import { BEIGE_300, BEIGE_600, GRAY_900 } from 'constants/styling/theme'
import { Stack, Typography } from '@mui/material'

import { BorderBoxWrapper } from 'components/common/BorderBoxWrapper'
import { FC } from 'react'
import { useClientPhotoStudio } from '../ClientPhotoStudio.context'
import { useTranslation } from 'react-i18next'

const INSTRUCTIONS_TEXT_SX = {
  fontSize: '1.4rem',
  lineHeight: '1.4',
  letterSpacing: '-0.56px',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  width: '100%',
} as const

/** "How to use the eraser" box — the Erase panel and the Erase section of "Display all features at once" */
export const EraserInstructions: FC = () => {
  const { t } = useTranslation(['photo_studio_editing'])
  const { isLabSdkEngine } = useClientPhotoStudio()

  return (
    <BorderBoxWrapper
      gap={0.2}
      padding={1.2}
      borderColor={BEIGE_600}
      backgroundColor={BEIGE_300}
      sx={{
        borderRadius: '0.8rem',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Stack gap={0.2} sx={{ width: '100%', maxWidth: '100%' }}>

        <Typography variant="text-sm" fontWeight={550} color={GRAY_900} sx={INSTRUCTIONS_TEXT_SX}>
          {t('eraser_instructions.title')}
        </Typography>

        <Typography variant="text-sm" fontWeight={350} color={GRAY_900} sx={INSTRUCTIONS_TEXT_SX}>
          {/* Lab SDK engine: one mask per order — the Lab eraser regenerates one area around everything marked */}
          {isLabSdkEngine ? t('lab.eraser.instructions') : t('eraser_instructions.description')}
        </Typography>

      </Stack>
    </BorderBoxWrapper>
  )
}
